import { PersonaOperationState, PersonaOperationStateType } from '../../types';

export function isButtonVisible(buttonState: PersonaOperationState): boolean {
    return (
        buttonState.type === PersonaOperationStateType.Show ||
        buttonState.type === PersonaOperationStateType.Disabled
    );
}

export function isButtonEnabled(buttonState: PersonaOperationState): boolean {
    return buttonState.type === PersonaOperationStateType.Show;
}

export function isButtonDisabled(buttonState: PersonaOperationState): boolean {
    return buttonState.type === PersonaOperationStateType.Disabled;
}
